import { LuSun, LuMoon, LuMonitor } from 'react-icons/lu'
import { useTheme } from '@contexts/ThemeContext'
import { cn } from '@lib/cn'

interface ThemeToggleProps {
  variant?: 'icon' | 'select'
  className?: string
}

export function ThemeToggle({ variant = 'icon', className }: ThemeToggleProps) {
  const { theme, setTheme, resolvedTheme } = useTheme()

  if (variant === 'select') {
    return (
      <div className={cn('flex items-center gap-2', className)}>
        <button
          type="button"
          onClick={() => setTheme('light')}
          className={cn(
            'p-2 rounded-lg transition-colors',
            theme === 'light'
              ? 'bg-sky-600 text-white'
              : 'text-[var(--color-text-secondary)] hover:bg-[var(--color-surface)]'
          )}
          aria-label="Light theme"
          aria-pressed={theme === 'light'}
        >
          <LuSun className="w-5 h-5" />
        </button>
        <button
          type="button"
          onClick={() => setTheme('dark')}
          className={cn(
            'p-2 rounded-lg transition-colors',
            theme === 'dark'
              ? 'bg-sky-600 text-white'
              : 'text-[var(--color-text-secondary)] hover:bg-[var(--color-surface)]'
          )}
          aria-label="Dark theme"
          aria-pressed={theme === 'dark'}
        >
          <LuMoon className="w-5 h-5" />
        </button>
        <button
          type="button"
          onClick={() => setTheme('system')}
          className={cn(
            'p-2 rounded-lg transition-colors',
            theme === 'system'
              ? 'bg-sky-600 text-white'
              : 'text-[var(--color-text-secondary)] hover:bg-[var(--color-surface)]'
          )}
          aria-label="System theme"
          aria-pressed={theme === 'system'}
        >
          <LuMonitor className="w-5 h-5" />
        </button>
      </div>
    )
  }

  // Icon variant - single toggle button
  const handleToggle = () => {
    if (theme === 'system') {
      setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')
    } else {
      setTheme(theme === 'dark' ? 'light' : 'dark')
    }
  }

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={cn(
        'p-2 rounded-lg transition-colors',
        'text-[var(--color-text-secondary)] hover:bg-[var(--color-surface)]',
        className
      )}
      aria-label={`Switch to ${resolvedTheme === 'dark' ? 'light' : 'dark'} theme`}
    >
      {resolvedTheme === 'dark' ? (
        <LuSun className="w-5 h-5" />
      ) : (
        <LuMoon className="w-5 h-5" />
      )}
    </button>
  )
}
